// «Строка принадлежит ЖИВОМУ материалу» — ОДИН предикат для локального SQLite.
//
// ПОЧЕМУ ОДИН. Производные сущности (термины глоссария, слабые места) живут в
// своих таблицах и ссылаются на материал колонкой `material_id`. Часть из них
// сервер гасит каскадом при удалении материала (`glossary_terms.deleted_at`), а
// часть не гасит вовсе (`weak_spots` — там нет `deleted_at` и никогда не было):
// серверные списки просто ОТСЕКАЮТ такие строки джойном с `materials`
// (`weak-spots/queries/list.ts`). Клиент читает те же таблицы напрямую из
// PowerSync, поэтому обязан повторить ровно тот же отбор — иначе раздел
// показывает данные материала, которого пользователь уже удалил.
//
// К 2026-08-21 копий предиката было ДВЕ с половиной, и расходились они молча:
// бейджи навигации («Слабые места 37», «Глоссарий 421») условие СЧИТАЛИ, а
// списки этих же разделов — нет. Число в сайдбаре уменьшалось, экран оставался
// прежним. Теперь предикат один, и правится он тут.
//
// ФОРМА. `EXISTS`, а не `LEFT JOIN ... IS NULL`: подзапрос не размножает
// строки (важно для агрегатов) и подставляется в любой `WHERE` без правки
// `FROM`. `material_id IS NULL` — законный случай (термин темы курса, пробел
// без материала-владельца), такие строки живут своей жизнью и остаются.
//
// ОТСУТСТВИЕ строки `materials` локально трактуется как «материала нет»:
// стримы PowerSync отдают только живые материалы, а после подтверждения
// удаления tombstone уезжает и строка исчезает совсем. Условие «покажи, если
// есть ЖИВОЙ материал» одинаково верно и до, и после этого момента — в отличие
// от «спрячь, если есть tombstone», которое вернуло бы строку на экран ровно в
// момент, когда удаление окончательно закрепилось.

/**
 * Предикат для `WHERE`: владелец строки — живой материал (или ссылки нет вовсе).
 *
 * @param alias алиас таблицы-владельца в запросе (например `w` для `weak_spots w`)
 * @param column колонка со ссылкой на материал
 */
export function belongsToLiveMaterial(alias: string, column = "material_id"): string {
	return `(${alias}.${column} IS NULL OR EXISTS (
		SELECT 1 FROM materials live_m
		WHERE live_m.id = ${alias}.${column} AND live_m.deleted_at IS NULL
	))`;
}
